<template>
  <div class="eventsGallery px-3">
    <h1 class="center-header text-center mx-auto eventsGallery__title">Events</h1>
    <br /><br />
    <div class="container">
      <div v-for="(chunk, index) in chunkedEvents" :key="index" class="row d-flex flex-wrap justify-content-between">
        <a
          v-for="event in chunk"
          :key="event.link"
          :href="event.link"
          class="col-lg-4 col-md-6 col-sm-12 my-3 eventsGallery__box"
          target="_blank"
          rel="noopener noreferrer"
        >
          <figure>
            <img :src="event.image" alt="Event image" class="eventsGallery__img" />
            <h3 class="text-center mt-3 eventsGallery__box-h">{{ event.title }}</h3>
            <p class="eventsGallery__box-p">
              {{ event.date }} <br />
              <i class="fas fa-map-marker-alt blue"></i>
              <span class="blue mx-2">{{ event.location }}</span>
            </p>
          </figure>
        </a>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventsGallery',
  data() {
    return {
      events: [
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_itw2025-keepingtheworldconnected-inteqt-activity-7323719026596073476-sDhS?utm_source=share&utm_medium=member_desktop&rcm=ACoAADWwxKcBI0BREvIY19bExq4WeJKoDAUgNyg',
          image: '/images/y1G9poB.jpg',
          title: 'International Telecoms Week 2024',
          date: '5 - 7 May 2025',
          location: 'Gaylord National Resort & Convention Centre National Harbor, MD',
        },
        {
          link: 'https://www.linkedin.com/posts/dagagaurav_channelpartners-sdwan-connectivity-activity-7306338847896862722-BxOt?utm_source=share&utm_medium=member_desktop&rcm=ACoAADWwxKcBI0BREvIY19bExq4WeJKoDAUgNyg',
          image: '/images/6G5KxAG.jpg',
          title: 'Channel Partners Conference & Expo 2025',
          date: '24 - 25 March 2025',
          location: 'The Venetian Resort in Las Vegas',
        },
        {
          link: 'https://www.linkedin.com/posts/dagagaurav_inteqt-weareinteqt-internetaggregator-activity-7247932957078736898-fgwI?utm_source=share&utm_medium=member_ios',
          image: '/images/XAx622Y.jpg',
          title: 'Capacity Europe 2024',
          date: '15 - 17 October 2024',
          location: 'InterContinental London - The 02',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_itwafrica-itw2024-keepingtheworldconnected-activity-7231657540122513408-k4uO?utm_source=share&utm_medium=member_ios',
          image: '/images/IJBhBsd.jpg',
          title: 'ITW Africa And Data Cloud Africa 2024',
          date: '10 - 12 September 2024',
          location: 'Kenya',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_aslan2024-madrid-aslan-activity-7185596782733574144-w5yd?utm_source=share&utm_medium=member_ios',
          image: '/images/43lN9Po.jpg',
          title: 'Aslan 2024',
          date: '17 - 18 April 2024',
          location: 'Palacio de Congresos de IFEMA',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_inte-qt-at-itw-2024-activity-7191032993136701440-QJAv?utm_source=share&utm_medium=member_ios',
          image: '/images/N9WxHdS.jpg',
          title: 'International Telecoms Week 2024',
          date: '14 - 17 May 2024',
          location: 'Gaylord National Resort & Convention Centre National Harbor, MD',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_capacitymiddleeast-capacitymedia-telecoms-activity-7153755223310675969-Uh3v?utm_source=share&utm_medium=member_ios',
          image: '/images/RHoqD2S.jpg',
          title: 'Capacity Middle East 2024',
          date: '5 - 8 February 2024',
          location: 'Grand Hyatt Dubai, UAE',
        },
        {
          link: 'https://www.linkedin.com/posts/dagagaurav_ptc2024-api-hawaii-activity-7150533292499292162-svt6?utm_source=share&utm_medium=member_ios',
          image: '/images/uC4mK8p.jpg',
          title: 'PTC 2024',
          date: '21 - 24 January 2024',
          location: 'Honolulu, Hawaii',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_conference-businessoutcomes-telecommunications-activity-7130910010393423872-B4zF?utm_source=share&utm_medium=member_ios',
          image: '/images/nAkVeWK.jpg',
          title: 'Total Telecom Congress 2023',
          date: '21 - 22 November 2023',
          location: 'The Rai, Amsterdam',
        },
        {
          link: 'https://www.linkedin.com/posts/dagagaurav_london-capacityeurope2023-internetaccess-activity-7117125137639911424-XD8D?utm_source=share&utm_medium=member_ios',
          image: '/images/1Qkqrmn.jpg',
          title: 'Capacity Europe 2023',
          date: '17 - 19 October 2023',
          location: 'London, UK',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_itw2023-activity-7054431720669888512-dq_M?utm_medium=member_ios&utm_source=social_share_video',
          image: '/images/b0C0jRl.jpg',
          title: 'International Telecoms Week 2023',
          date: '14 - 17 May 2023',
          location: 'Gaylord National Resort & Convention Centre National Harbor, MD',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_ifemamadrid-access-sdwan-activity-6991348989002452993-OW4Y?utm_source=share&utm_medium=member_desktop',
          image: '/images/vIt6jue.jpg',
          title: 'Cloud Expo Europe 2022',
          date: '28 - 29 October 2022',
          location: 'Madrid, ES',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_capacityeurope-telecoms-events-activity-6983397911896182785-qPYo?utm_source=share&utm_medium=member_android',
          image: '/images/89ne2Om.jpg',
          title: 'Capacity Europe 2022',
          date: '17 - 20 October 2022',
          location: 'International Continental London - The 02, London, UK',
        },
        {
          link: 'https://www.linkedin.com/feed/update/urn:li:activity:6932313942992011264',
          image: '/images/xr6bTxU.png',
          title: 'Congreso & EXPO ASLAN 2022',
          date: '18 - 19 May 2022',
          location: 'Madrid, ES',
        },
        {
          link: 'https://www.linkedin.com/feed/update/urn:li:activity:6924719247508054016',
          image: '/images/PtT5HIy.png',
          title: 'International Telecoms Week 2022',
          date: '09 - 12 May 2022',
          location: 'Washington, USA',
        },
        {
          link: 'https://www.linkedin.com/feed/update/urn:li:activity:6911638923874025473',
          image: '/images/lrhjjW8.png',
          title: 'Capacity Middle East 2022',
          date: '28 - 31 March 2022',
          location: 'Dubai, UAE',
        },
        {
          link: 'https://www.linkedin.com/feed/update/urn:li:activity:6909115405546450944',
          image: '/images/Yyylbtx.png',
          title: 'GCCM London 2022',
          date: '14 - 15 March 2022',
          location: 'London, UK',
        },
        {
          link: 'https://www.linkedin.com/feed/update/urn:li:activity:6902921111361974272/',
          image: '/images/6BUFQXx.jpg',
          title: 'MWC Barcelona 2022',
          date: '28 Feb - 03 March 2022',
          location: 'Spain, ES',
        },
        {
          link: 'https://www.linkedin.com/feed/update/urn:li:activity:6876121511753719808',
          image: '/images/3SbymtI.jpg',
          title: 'SDWAN and SASE Summit 2021',
          date: '14 - 16 December 2021',
          location: 'Paris, FR',
        },
        {
          link: 'https://www.linkedin.com/posts/bitsandbyteglobal_capacityeurope2021-internetaccess-event-activity-6855817706504114176-o3eT',
          image: '/images/a9Bq1EA.jpg',
          title: 'Capacity Europe 2021',
          date: '18 - 21 October 2021',
          location: 'Virtual',
        }
      ],
    };
  },
  computed: {
    chunkedEvents() {
      const chunked = [];
      for (let i = 0; i < this.events.length; i += 3) {
        chunked.push(this.events.slice(i, i + 3));
      }
      return chunked;
    },
  },
};
</script>

<style scoped>
.eventsGallery {
  margin-top: 8rem;
  color: #000;
}

.eventsGallery__title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 2rem;
}

.eventsGallery__box {
  display: inline-flex;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
  text-decoration: none;
  color: #000;
  transition: all 0.3s ease-in-out;
}

.eventsGallery__box:hover {
  text-decoration: none;
}

.eventsGallery__img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease-in-out;
}

.eventsGallery__img:hover {
  transform: scale(1.1);
}

.eventsGallery__box-h {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 1rem;
  text-align: center;
}

.eventsGallery__box-p {
  font-size: 1rem;
  color: #666;
  text-align: center;
  padding: 1rem;
}

.center-header {
  text-align: center;
}

.blue {
  color: #007bff;
}

hr {
  margin-top: 2rem;
  border-color: #ccc;
}
</style>
